import React from 'react';
import * as S from './styles';
import { TextProps } from './types';

function ForwardedText<As extends React.ElementType = 'span'>(
  {
    align,
    as,
    children,
    letterSpacing,
    lineHeight,
    size,
    textTransform,
    variant,
    weight,
    ...props
  }: TextProps<As>,
  ref: React.ForwardedRef<React.ElementRef<As>>,
): React.ReactElement | null {
  const Component: React.ElementType = as ?? 'span';

  return (
    <S.Container
      $align={align}
      $letterSpacing={letterSpacing}
      $lineHeight={lineHeight}
      $size={size}
      $textTransform={textTransform}
      $variant={variant}
      $weight={weight}
      as={Component}
      {...props}
      ref={ref}
    >
      {children}
    </S.Container>
  );
}

export const Text = React.forwardRef(ForwardedText) as <
  As extends React.ElementType = 'span',
>(
  props: TextProps<As> & { ref?: React.Ref<React.ElementRef<As>> },
) => React.ReactElement | null;

export default Text;
